import { useState, useCallback } from 'react';
import { ConfirmModalConfig } from '@/components/GlobalModal';

export const useConfirmModal = () => {
  const [config, setConfig] = useState<ConfirmModalConfig>({
    visible: false,
    type: 'custom',
  });

  const showConfirmModal = useCallback((
    type: 'release' | 'pause' | 'delete' | 'advance' | 'publish' | 'resume' | 'custom',
    options?: {
      data?: { 
        name?: string; 
        version?: string; 
        title?: string; 
        id?: string; 
        currentPhase?: number;
        nextPhase?: number;
        [key: string]: any 
      };
      deleteConfig?: {
        itemName?: string;
        warningText?: string;
        showWarning?: boolean;
      };
      advanceConfig?: {
        currentPercentage?: number;
        nextPercentage?: number;
        hintText?: string;
      };
      title?: string;
      content?: React.ReactNode;
      onConfirm?: () => void;
      onCancel?: () => void;
      okText?: string;
      cancelText?: string;
      okButtonProps?: any;
      cancelButtonProps?: any;
      width?: number;
    }
  ) => {
    setConfig({
      visible: true,
      type,
      ...options,
    });
  }, []);

  const hideConfirmModal = useCallback(() => {
    setConfig(prev => ({
      ...prev,
      visible: false,
    }));
  }, []);

  const handleConfirm = useCallback(() => {
    // 先保存回调函数（在 hideConfirmModal 之前保存，避免状态丢失）
    const onConfirmCallback = config.onConfirm;
    
    // 如果有回调函数，先调用回调（在关闭弹窗前调用，确保回调函数能访问到完整的 config）
    if (onConfirmCallback) {
      onConfirmCallback();
    }
    
    // 调用完回调后再重置状态
    hideConfirmModal();
  }, [config, hideConfirmModal]);

  const handleCancel = useCallback(() => {
    config.onCancel?.();
    hideConfirmModal();
  }, [config, hideConfirmModal]);

  return {
    config,
    showConfirmModal,
    hideConfirmModal,
    handleConfirm,
    handleCancel,
  };
};
